import React from "react";
import { DataItem } from "@/shared/widgets/DataSection";
import { Icon } from "@/shared/ui/Icon";
import { useAttachmentRead } from "@/shared/hooks/content/useAttachments";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/shared/ui/HoverCard";

interface FileMentionProps {
  name: string;
  file_id: number;
  tagLabel?: string;
  description?: string;
  position_id?: number;
  person_id?: number;
}

const FileMention: React.FC<FileMentionProps> = ({
  name,
  file_id,
  tagLabel,
  description,
  position_id,
  person_id,
}) => {
  const { readAttachment } = useAttachmentRead({ position_id, person_id });
  const handleClick = async () => {
    await readAttachment(file_id);
  };
  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <span
          className="inline-flex align-bottom mt-2 items-center gap-2 p-2 py-1 rounded-full text-sm font-medium text-gray-700 border border-gray-700 not-prose cursor-pointer hover:bg-gray-700 hover:text-white hover:border-gray-700 group"
          onClick={handleClick}
        >
          <Icon icon="File" size="xs" className="group-hover:text-white" />
          <span className="leading-none">{tagLabel || name}</span>
        </span>
      </HoverCardTrigger>
      <HoverCardContent>
        <div className="space-y-2">
          <DataItem
            className="border-none"
            type="file"
            label={name}
            tagLabel={tagLabel}
            removable={false}
          />
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};

export default FileMention;
